(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  let observer;
  const enabled = () => document.body.dataset.rfMotion === 'true' && !preference.matches && !window.Shopify?.designMode;
  const reveal = (element, delay = 0) => {
    if (!enabled() || !element.animate) return;
    const animation = element.animate([{ opacity: .65, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 620, delay, easing: 'cubic-bezier(.2,.65,.3,1)' });
    running.add(animation);
    animation.onfinish = animation.oncancel = () => running.delete(animation);
  };
  const initialize = (root = document) => {
    if (!enabled() || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver((entries) => {
      let index = 0;
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(index++ * 55, 165));
      });
    }, { threshold: .08 });
    root.querySelectorAll('.rf-path,.rf-section-head,.rf-finder-card,.rf-editorial__image,.rf-editorial__copy,.rf-faq__intro,.rf-faq__items,.rf-box-benefits__card').forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  };
  const start = () => {
    initialize();
    if (enabled()) document.querySelectorAll('.rf-hero__copy,.rf-hero__visual').forEach((element,index) => reveal(element,index*90));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  preference.addEventListener('change', () => {
    if (preference.matches) { observer?.disconnect(); running.forEach((animation) => animation.cancel()); }
    else initialize();
  });
  window.addEventListener('pagehide', () => running.forEach((animation) => animation.cancel()));
})();
  } catch(e) { console.error(e); }
})();

})();
